import ajaxSettingsForm from '../scripts/ajaxSettingsForm';
import ajaxApiTest from '../scripts/ajaxApiTest';

export default function (el) {
    return {
        el,
        data() {
            const data = JSON.parse(el.getAttribute('data'));

            // Select the first tab on the left by default ("Connection")
            data.activeTab = 0;

            return data;
        },
        methods: {
            ajaxUpdateSettings(ajaxSettingsFormInjection = null) {
                this.loading = true;
                this.notices = [];

                let formHandler = ajaxSettingsFormInjection || ajaxSettingsForm;

                return formHandler().then((data) => {
                    if (data.notices) {
                        this.notices = data.notices;
                    }

                    this.api_url = data.api_url;
                    this.api_key = data.api_key;
                    this.ac_debug = data.ac_debug;
                    this.abcart_wait = data.abcart_wait;
                    this.optin_checkbox_text = data.optin_checkbox_text;
                    this.checkbox_display_option = data.checkbox_display_option;
                    this.custom_email_field = data.custom_email_field;

                    this.loading = false;
                }).catch((error) => {
                    if (error.errors) {
                        this.notices = error.errors;
                    }

                    this.api_url = error.api_url;
                    this.api_key = error.api_key;
                    this.ac_debug = error.ac_debug;
                    this.abcart_wait = error.abcart_wait;
                    this.optin_checkbox_text = error.optin_checkbox_text;
                    this.checkbox_display_option = error.checkbox_display_option;
                    this.custom_email_field = error.custom_email_field;

                    this.loading = false;
                });
            },
            ajaxFixConnection() {
                if (confirm("Please confirm that you would like to reset your connection ID.")) {
                    const nonceVal = jQuery('#activecampaign_for_woocommerce_settings_nonce_field');
                    jQuery.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: "activecampaign_for_woocommerce_reset_connection_id",
                            activecampaign_for_woocommerce_settings_nonce_field: nonceVal.attr('value')
                        }
                    }).done(response => {
                        jQuery('#activecampaign-run-fix-connection-status').html( response.data );
                    }).fail(response => {
                        jQuery('#activecampaign-run-fix-connection-status').html( response.data );
                    });
                }
            },
            ajaxClearPluginSettings(){
                if(confirm("Are you sure you want to erase all settings? This plugin will not function until proper API settings have been set again.")) {
                    const nonceVal = jQuery('#activecampaign_for_woocommerce_settings_nonce_field');
                    jQuery.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: "activecampaign_for_woocommerce_clear_all_settings",
                            activecampaign_for_woocommerce_settings_nonce_field: nonceVal.attr('value')
                        }
                    }).done(response => {
                        jQuery('#activecampaign-run-clear-plugin-settings-status').html( response.data );
                    }).fail(response => {
                        jQuery('#activecampaign-run-clear-plugin-settings-status').html( response.data );
                    });
                }else{
                    return false;
                }
            },
            testAcApi() {
                return ajaxApiTest().then((data) => {
                    if (data.notices) {
                        this.notices = data.notices;
                    }
                }).catch((error) => {
                    if (error.errors) {
                        this.notices = error.errors;
                    }
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./admin/src/js/components/RootApp.js